import React from "react";

const Guarantee = () => (
  <section className="guarantee" aria-labelledby="guarantee-title">
    <div className="container">
      <div className="grid">
        <div className="seal" aria-hidden="true">
          <span className="num">30</span>
          <span className="lab">Day Refund</span>
        </div>
        <div>
          <h2 id="guarantee-title">
            If you don't love it, we'd rather refund you than keep your money.
          </h2>
          <p>
            30 days from enrolment to ask for a full refund. No questions, no
            exit interview. Replies within 24 hours, often sooner.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Guarantee;
